module.exports = __webpack_public_path__ + "static/main_author-b426359cd5ad45a8088131885fb85a19.png";